export const getCDN = () => {
    if(window.location.origin === 'https://www.tap2buy.com' || window.location.origin === 'https://live-giftguru.dnrx1u9c16dvg.amplifyapp.com') {
        return "https://cdn.tap2buy.com/" 
    } else {
        return "https://cdn-staging.securemobile.net/"
    }
}